import { useEffect, useState } from "react";

import { Locale } from "@/Common/Models/Localization/Locale";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { ResourceProvider } from "@/Common/Resources/StaticResources";
import { LoginPage as MyleResoucesForLoginPage } from "@/Common/Resources/StaticResourcesFor";
import { Logo } from "@/DesignSystem/Atoms/Logo/Logo";
import { LoginLanguageHelper } from "./Login/Helpers/LoginLanguageHelper";
import { LoginForm } from "./LoginForm";
import { VersionCheck } from "./VersionCheck";

import styles from "./ReLoginPage.module.scss";

export function ReLoginPage(): JSX.Element {
    const [stringProvider, setStringProvider] = useState<ResourceProvider>();
    const [language, setLanguage] = useState<Locale>();

    useEffect(() => {
        if (!sessionStore.userId) {
            sessionStore.toggleNavigationPrompt(false);
            document.location.href = rootPath;
        }
    });

    useEffect(() => {
        const resources = new MyleResoucesForLoginPage();
        const currentLanguage = LoginLanguageHelper.getFirstLanguage(window["currentLang"]);

        setLanguage(currentLanguage);
        setStringProvider(new ResourceProvider(resources, currentLanguage));
    }, [language]);

    if (!stringProvider)
        return null;

    return (
        <div className={styles.mainContainer}>
            <VersionCheck />
            <div className={styles.loginContainer}>
                <div className={styles.logoContainer}>
                    <Logo language={language} />
                </div>
                <LoginForm
                    loginButtonTextKey="RestoreLabel"
                    formTitle={stringProvider.GetString("SessionExpiredLabel")}
                    language={language}
                    stringProvider={stringProvider}
                    loginOperation={LocalOperations.Login.RestoreSession}
                    isUserRelogin
                />
                <div className={styles.copyrightContainer}>
                    &copy; {stringProvider.GetString("MedfarCopyRightLabel", { year: new Date().getFullYear() })}
                </div>
            </div>
        </div>
    );
}
